/* eslint-disable max-classes-per-file */
import { Location, MemoryHistory } from 'history';
import React from 'react';
import { Helmet } from 'react-helmet-async';
import { MatchedRoute } from 'react-router-config';
import { Store } from 'redux';
import { MatchProps } from './components/EpisodeEditorPublish/types';
import { getPageTitle, Page } from './getPageTitle';
import { useT } from './i18n/hooks/useT';

type WithTitleProps = {
  page?: Page;
  BaseComponent: React.ComponentType & {
    fetchData?: (data: FetchDataProps) => void;
  };
};

type FetchDataProps = {
  history: MemoryHistory;
  match: MatchProps;
  location: Location;
  store: Store<any>;
  baseUrl: string;
  route: MatchedRoute<{
    [x: string]: string;
  }>;
};

export const Title = ({ title, page }: { title?: string; page?: Page }) => {
  const t = useT();
  const pageTitle =
    title ||
    (page
      ? getPageTitle(page as Page, t)
      : t(
          'PageTitle.Default',
          'Anchor - The easiest way to make a podcast',
          'Default page title'
        ));

  return (
    <Helmet>
      <title>{pageTitle}</title>
      <meta property="og:title" content={pageTitle} />
      <meta name="twitter:title" content={pageTitle} />
    </Helmet>
  );
};

export const WithTitle = ({ page, BaseComponent }: WithTitleProps) => {
  const WithTitleComponent = (props: any) => {
    return (
      <>
        <Title page={page} />
        <BaseComponent {...props} />
      </>
    );
  };

  if (BaseComponent.fetchData) {
    WithTitleComponent.fetchData = BaseComponent.fetchData;
  }

  return WithTitleComponent;
};
